import { Navigate, useParams, useSearchParams } from 'react-router-dom';

// ラベルQRの短縮リンク。QRのモジュール数を下げるために存在する（23×23ロールで
// 0.33mm/モジュールの下限を満たすため）。種別文字で行き先が一意に決まるので
// 台帳をまたいだ検索は不要。旧URL（/engineering?open=、/engineering/equipment?open=）も
// そのまま解決するので、既に貼られたラベルは影響を受けない。
const DEST = { a: '/engineering/assets', e: '/engineering/equipment' };

export default function QrShortLink() {
  const { kind, id } = useParams();
  const base = DEST[kind];
  if (!base || !id) return <Navigate to="/" replace />;
  return <Navigate to={`${base}?open=${encodeURIComponent(id)}`} replace />;
}

// 旧ラベルの互換。技術資産一覧が /engineering から /engineering/assets へ移動したため、
// 移動前に印刷されたラベルの ?open= が技術部ダッシュボードに落ちて無反応になっていた。
// ?open= が付いている場合だけ一覧へ送る。
export function LegacyAssetOpenRedirect({ children }) {
  const [sp] = useSearchParams();
  const id = sp.get('open');
  if (id) return <Navigate to={`/engineering/assets?open=${encodeURIComponent(id)}`} replace />;
  return children;
}
